var modules_efad2c92 = {"link":"_10kamll"};
import "../../../assets/CHUe3II_.css";

export { modules_efad2c92 as default };
//# sourceMappingURL=ContactsBanner.module.less.js.map
